import { render, staticRenderFns } from "./GlobalSetting.vue?vue&type=template&id=491e02de&scoped=true"
import script from "./GlobalSetting.vue?vue&type=script&lang=js"
export * from "./GlobalSetting.vue?vue&type=script&lang=js"
import style0 from "./GlobalSetting.vue?vue&type=style&index=0&id=491e02de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e02de",
  null
  
)

export default component.exports